const DEFAULT_CURRENCY = 'RUB'

export function normalizeCurrencyCode(value) {
  if (typeof value !== 'string') {
    return ''
  }

  return value.trim().toUpperCase()
}

export function pickPreferredCurrency(currency, fallbackCurrency = DEFAULT_CURRENCY) {
  const normalizedCurrency = normalizeCurrencyCode(currency)
  const normalizedFallbackCurrency = normalizeCurrencyCode(fallbackCurrency)

  if (normalizedCurrency && (normalizedCurrency !== DEFAULT_CURRENCY || normalizedFallbackCurrency === DEFAULT_CURRENCY || !normalizedFallbackCurrency)) {
    return normalizedCurrency
  }

  return normalizedFallbackCurrency || normalizedCurrency || DEFAULT_CURRENCY
}

export function getCurrencyCode(currency, fallbackCurrency = DEFAULT_CURRENCY) {
  return normalizeCurrencyCode(currency)
    || normalizeCurrencyCode(fallbackCurrency)
    || DEFAULT_CURRENCY
}

export function normalizePrice(price, fallbackCurrency = DEFAULT_CURRENCY) {
  if (price && typeof price === 'object' && !Array.isArray(price)) {
    const value = Number(price.value ?? price.price ?? 0)

    return {
      ...price,
      value: Number.isFinite(value) ? value : 0,
      currency: pickPreferredCurrency(price.currency, fallbackCurrency)
    }
  }

  const value = Number(price ?? 0)

  return {
    value: Number.isFinite(value) ? value : 0,
    currency: getCurrencyCode(undefined, fallbackCurrency)
  }
}

export function formatCurrencyPrice(price, fallbackCurrency = DEFAULT_CURRENCY, options = {}) {
  const normalizedPrice = normalizePrice(price, fallbackCurrency)
  const locale = options.locale || 'ru-RU'
  const minimumFractionDigits = Number.isFinite(options.minimumFractionDigits)
    ? options.minimumFractionDigits
    : 0

  try {
    const formatterOptions = {
      style: 'currency',
      currency: normalizedPrice.currency,
      minimumFractionDigits
    }

    if (Number.isFinite(options.maximumFractionDigits)) {
      formatterOptions.maximumFractionDigits = options.maximumFractionDigits
    }

    return new Intl.NumberFormat(locale, formatterOptions).format(normalizedPrice.value)
  } catch (error) {
    return `${new Intl.NumberFormat(locale).format(normalizedPrice.value)} ${normalizedPrice.currency}`
  }
}
